import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import languages from "languages/languages";
import styles from "./RestaurantFavourites.module.css";
import phoneBlack from "assets/images/icon-phone-black.svg";
import RestaurantFavouritesSkeleton from "./skeleton/RestaurantFavouritesSkeleton";
import playClickSpecial from "utils/playClickSpecial";
import placeholder1000x625 from "assets/placeholder/1000x625.png";

function RestaurantFavourites(props) {
  const langState = useSelector((state) => state.language.lang);
  const location = useLocation();
  const pathname = location.pathname;
  const { favourite, loading } = props;

  if (!favourite || loading) {
    return <RestaurantFavouritesSkeleton />;
  }

  return (
    <>
      <div className={styles.item_categories}>
        <h2 className={styles.title_categories}>
          {languages[langState]["Được yêu thích"]}
        </h2>
        <div className={styles.wrapp_item_content}>
          <h4 className={styles.title}>{favourite.title}</h4>
          <div className={styles.phone_number}>
            {favourite.phone && (
              <>
                <img src={phoneBlack} className={styles.phone_image} alt="" />
                {favourite.phone}
              </>
            )}
          </div>
          <div className={styles.item_image}>
            {favourite.id && favourite.code ? (
              <Link
                to={{
                  pathname: `${pathname}/${favourite.id}`,
                  search: `?code=${favourite.code}`,
                }}
                onClick={playClickSpecial}
              >
                <img
                  src={favourite.photo || placeholder1000x625}
                  alt={favourite.title}
                />
              </Link>
            ) : (
              <img
                src={favourite.photo || placeholder1000x625}
                alt={favourite.title}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default RestaurantFavourites;
